import themes from './theme.json';
import myStorage from '../storage';
import pinia from '@/store/store';
import { store } from '@/store/index';
import { storeToRefs } from 'pinia';
export function addColor(theme: any) {
  const piniaStore: any = store(pinia);
  const { defaultColor, obj = {} } = themes;
  if (theme) {
    Object.assign(obj, theme);
  } else {
    Object.assign(obj, defaultColor);
  }
  for (const key in obj) {
    document.documentElement.style.setProperty(key, obj[key]);
  }
}
